import React from 'react';


const Icon = ({name, sr}) => (
    <i className={'fas fa-'+name+ ' text-secondary mr-2'}>
        <span className="sr-only">{sr}</span>
    </i> 
)

export default Icon;